// Vietnamese translations (Tiếng Việt)
import type { TranslationKeys } from './en';

export const vi: TranslationKeys = {
  // Common
  common: {
    home: 'Trang chủ',
    settings: 'Cài đặt',
    language: 'Ngôn ngữ',
    loading: 'Đang tải...',
    save: 'Lưu',
    cancel: 'Hủy',
    confirm: 'Xác nhận',
    close: 'Đóng',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Cài đặt',
    home: 'Trang chủ',
    howToPlay: 'Cách chơi',
    pieceRules: 'Quy tắc quân cờ',
    language: 'Ngôn ngữ',
    manageSubscription: 'Quản lý đăng ký',
    gameHistory: 'Lịch sử trận đấu',
    analytics: 'Phân tích',
    premiumAccount: 'Tài khoản Premium',
    chatEnabled: 'Trò chuyện: Bật',
    chatDisabled: 'Trò chuyện: Tắt',
  },

  // Piece Rules
  pieceRules: {
    title: 'Quy tắc quân cờ',
    description: 'Học cách di chuyển quân cờ',
    selectPiece: 'Chọn quân cờ',
    selectedLabel: 'Đã chọn:',
    statusLabel: 'Trạng thái:',
    statusReady: 'Sẵn sàng',
    statusViewing: 'Đang xem',
    movement: 'Di chuyển',
    regularMovement: 'Di chuyển thường',
    ability: 'Kỹ năng',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Di chuyển',
    savage: 'Hung dữ',
    birdtype: 'Loài chim',
    birdType: 'Loài chim',
    wallBlock: 'Chặn tường',
    moveblocks: 'Khối di chuyển',
    wallclimb: 'Leo tường',
    lilypad: 'Lá súng',
    poisonous: 'Độc',
    meadow: 'Đồng cỏ',
    parasiticfungi: 'Nấm ký sinh',
    zombification: 'Biến thành zombie',
    fungi: 'Nấm',
    traverse: 'Vượt qua',
    capture: 'Bắt',
    faint: 'Ngất',
    leap: 'Nhảy',
    swing: 'Đu',
    consume: 'Tiêu thụ',
    gamble: 'Đánh bạc',
    entangle: 'Vướng víu',
    ink: 'Mực',
    rotate: 'Xoay',
    backstep: 'Bước lùi',
    trample: 'Giẫm',
    charge: 'Lao',
    lane: 'Làn',
    snakestrike: 'Tấn công rắn',
    shedskin: 'Lột xác',
    house: 'Nhà',
    plant: 'Loài thực vật',
    planttype: 'Loài thực vật',
    capturehost: 'Bắt chủ nhà',
    contagion: 'Lây nhiễm',
    lonewolf: 'Sói đơn độc',
    hop: 'Nhảy nhót',
    decay: 'Phân hủy',
    slide: 'Trượt',
    block: 'Chặn',
    poison: 'Độc',
    infection: 'Nhiễm trùng',
    howl: 'Hú',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'Gấu có thể di chuyển một ô theo bất kỳ hướng nào, giống như vua trong cờ vua',
    bearMovementPost: 'Nó chỉ bị chặn bởi các quân cờ đồng minh (trừ Cây, Gấu có thể leo Cây!)',
    bearSavage: 'Gấu có thể vượt qua các khả năng phòng thủ như Chặn của Tê giác',
    bearSavagePost: 'Sử dụng Hung dữ, Gấu có thể bắt bất kỳ quân cờ nào từ bất kỳ hướng nào, tăng sức sát thương',

    // Crane
    craneMovement: 'Hạc có thể di chuyển 1 hoặc 2 ô theo bất kỳ đường thẳng nào',
    craneMovementPost: 'Hạc thậm chí có thể bay qua các quân cờ khác!',
    craneBirdType: 'Các quân cờ loài chim không thể bắt các quân cờ lớn hoặc săn mồi',
    craneBirdTypePost: 'Bao gồm Cây, Tê giác, Gấu và Sói',

    // Frog
    frogMovement: 'Ếch nhảy 2 ô theo đường chéo',
    frogMovementPost: 'Nó không thể chỉ nhảy một ô',
    frogWallBlock: 'Nếu đường đi thường 2 ô của Ếch bị chặn bởi tường hoặc quân cờ khác, nó không thể bắt',
    frogWallBlockPost: 'Di chuyển thường của nó được rút ngắn thành 1 ô theo đường chéo',
    frogWallClimb: 'Khi Ếch ở trên tường của bàn cờ (Cột A hoặc E), nó có thể di chuyển lên hoặc xuống một ô',
    frogWallClimbPost: 'Trừ khi bị chặn bởi quân cờ đồng minh hoặc Tê giác phía trước Ếch',
    frogLilypad: 'Nếu Ếch chưa di chuyển trong một ván, nó có thể di chuyển đến bất kỳ hàng nào trong 3 hàng đầu tiên như một khả năng phòng thủ mạnh mẽ',
    frogLilypadPost: 'Nó có thể bắt bất kỳ quân cờ thường nào bằng Nhảy lá súng, trừ Tê giác ở hàng cao hơn',
    frogPoisonous: 'Khi bất kỳ động vật nào bắt quân cờ Ếch, bạn sẽ bị nhiễm độc!',
    frogPoisonousPost: 'Quân cờ bị nhiễm độc bỏ lượt tiếp theo trước khi hồi phục',

    // Fungi
    fungiMovement: 'Nấm có thể di chuyển một ô theo bất kỳ hướng nào',
    fungiMovementPost: 'Nó chỉ bị chặn bởi các quân cờ đồng minh',
    fungiMeadow: 'Nấm làm giảm khả năng di chuyển của quân cờ Cây địch',
    fungiMeadowPost: 'Quân cờ Cây địch không thể di chuyển trong phạm vi 1 ô của quân cờ Nấm',
    fungiParasitic: 'Nấm có thể cố định quân cờ Cây địch',
    fungiParasiticPost: 'Nếu Nấm trong phạm vi 1 ô của Cây địch, nó không thể di chuyển cho đến khi Nấm di chuyển ra hoặc bị bắt',
    fungiZombification: 'Nấm có thể biến bất kỳ quân cờ động vật địch nào bắt nó thành zombie, cho phép kiểm soát động vật địch trong một lượt',
    fungiZombificationPost: 'Quân cờ zombie cũng được coi là quân cờ Nấm cho lượt đó, ngay cả khi Nấm là vua của bạn, trò chơi không kết thúc cho đến sau lượt đó',
    fungiFungi: 'Nấm',
    fungiFungiPost: 'Như độc, vướng víu và nhiễm virus, nhưng không phải biến zombie vì nó có thể biến người khác thành zombie!',

    // Goat
    goatMovement: 'Dê có thể di chuyển một ô theo bất kỳ hướng nào',
    goatMovementPost: 'Dê di chuyển chậm nhưng có khả năng mạnh mẽ',
    goatTraverse: 'Dê có thể vượt qua bất kỳ quân cờ được kết nối nào khác để tạo tiềm năng di chuyển lớn',
    goatTraversePost: 'Dê không thể vượt qua Dê Ngất hoặc các quân cờ Nhỏ như Virus',
    goatCapture: 'Dê không thể bắt bất kỳ Săn mồi nào',
    goatCapturePost: 'Như Gấu hoặc Sói',
    goatFaint: 'Dê có thể ngất để tránh bị bắt trừ các quân cờ lớn như Cây và Tê giác',
    goatFaintPost: 'Khi ngất, đối thủ có thể "đứng" trên dê ngất để ngăn chặn di chuyển của nó',

    // Monkey
    monkeyMovement: 'Khỉ có thể di chuyển một ô theo bất kỳ hướng nào',
    monkeyMovementPost: 'Không có các quân cờ khác để sử dụng, Khỉ có di chuyển hạn chế',
    monkeyLeap: 'Khỉ, giống như trò chơi cờ đam, có thể nhảy qua các quân cờ khác theo đường thẳng để có tiềm năng di chuyển lớn',
    monkeyLeapPost: 'Nhưng nếu nhảy qua quân cờ địch, Khỉ phải tung xúc xắc để sống sót qua cú nhảy, 1/6 cơ hội bị bắt cho mỗi kẻ địch nó nhảy qua!',
    monkeySwing: 'Nếu Khỉ sử dụng nhảy qua Cây, Khỉ nhận được lượt thưởng',
    monkeySwingPost: 'Sử dụng đu cây tạo ra combo phối hợp mạnh mẽ giữa các quân cờ Khỉ và Cây',
    monkeyConsume: 'Khỉ có thể tiêu thụ quân cờ Nấm để có lượt thưởng',
    monkeyConsumePost: 'Dẫn đến các kết hợp tàn phá khi kết hợp với các lượt thưởng khác',
    monkeyGamble: 'Ngoài việc tung xúc xắc để nhảy qua kẻ địch, Khỉ phải đánh bạc để bắt Gấu',
    monkeyGamblePost: 'Khỉ phải tung được 5 hoặc 6 trên xúc xắc 6 mặt để bắt Gấu hoặc chính nó bị bắt',

    // Octopus
    octopusMovement: 'Bạch tuộc di chuyển một ô theo bất kỳ hướng nào',
    octopusCapture: 'Bạch tuộc chỉ có thể bắt theo hướng trực giao',
    octopusCapturePost: 'Bạch tuộc có thể bắt hoặc vướng víu các quân cờ theo cách phức tạp, vì vậy hãy luôn kiểm tra bắt màu đỏ và vướng víu màu tím!',
    octopusEntangle: 'Bạch tuộc có thể vướng víu các quân cờ địch liền kề, cố định chúng, nó thậm chí có thể di chuyển một ô và vướng víu kẻ địch!',
    octopusEntanglePost: 'Các quân cờ bị vướng víu không thể di chuyển cho đến khi Bạch tuộc di chuyển ra hoặc bị bắt',
    octopusInk: 'Bạch tuộc có thể sử dụng mực để thoát khỏi tình huống nguy hiểm, tạo ra tối đa 3 bóng đen',
    octopusInkPost: 'Làm bối rối kẻ địch và cho phép các ván chơi mồi nhử và lẩn tránh thú vị',

    // Penguin
    penguinMovement: 'Chim cánh cụt trượt theo đường thẳng theo hướng đã đặt cho đến khi tường hoặc quân cờ chặn di chuyển của nó',
    penguinMovementPost: 'Sau khi di chuyển, Chim cánh cụt trong cùng lượt đó có thể đặt hướng cuối cùng của nó',
    penguinRotate: 'Khi bắt đầu trận đấu, Chim cánh cụt quay mặt xuống và phải xoay trước khi có thể trượt, còn được gọi là đang ngủ',
    penguinRotatePost: 'Chim cánh cụt ở bất kỳ vị trí nào có thể chọn xoay thay vì di chuyển',
    penguinBirdType: 'Chim cánh cụt có khả năng bắt hạn chế, giống như Hạc, nó không thể bắt các quân cờ lớn hoặc săn mồi như Cây, Tê giác, Gấu hoặc Sói',
    penguinBirdTypePost: 'Sau khi bắt, Chim cánh cụt có thể xoay theo bất kỳ hướng nào để định vị chiến lược',

    // Rhino
    rhinoMovement: 'Tê giác di chuyển hai ô chỉ về phía trước',
    rhinoMovementPost: 'Nó không thể chỉ di chuyển 1 ô',
    rhinoBackStep: 'Tê giác có thể di chuyển lùi-trái hoặc lùi-phải',
    rhinoCharge: 'Tê giác một lần mỗi ván có thể di chuyển thêm một ô về phía trước bằng khả năng lao của nó',
    rhinoChargePost: 'Dẫn đến tiềm năng di chuyển và bắt tàn phá',
    rhinoTrample: 'Tê giác bắt tất cả các quân cờ trên đường đi của nó bằng Giẫm',
    rhinoTramplePost: 'Bao gồm cả quân cờ Dê ngất',
    rhinoLane: 'Tê giác có thể đổi chỗ với quân cờ đồng minh khác cho phép chơi làn chiến lược',
    rhinoLanePost: 'Nhưng chỉ khi cả Tê giác và quân cờ Đồng minh đều chưa di chuyển',

    // Snake
    snakeMovement: 'Rắn có thể di chuyển 2 ô theo bất kỳ đường thẳng nào',
    snakeMovementPost: 'Rắn di chuyển chính xác 2 ô trừ khi bị chặn bởi tường hoặc quân cờ đồng minh',
    snakeMoveBlocks: 'Khi bị chặn bởi tường hoặc quân cờ nó không thể bắt, di chuyển của Rắn được rút ngắn thành 1 ô',
    snakeMoveBlocksPost: 'Nó vẫn có thể di chuyển hai ô ngay cả khi có quân cờ trung gian',
    snakeStrike: 'Rắn có thể tấn công 3 ô về phía trước nếu có động vật địch',
    snakeStrikePost: 'Miễn là không có quân cờ trung gian chặn đường của nó',
    snakeShedskin: 'Một lần mỗi ván, Rắn có thể lột xác và quay trở lại hàng đầu tiên nếu ô trống',
    snakeShedskinPost: 'Sự tái sinh này cho Rắn một mạng thêm mỗi ván',

    // Tree
    treeMovement: 'Cây có thể di chuyển một ô về phía trước hoặc đến bất kỳ ô nào trên hàng của nó từ bên này sang bên kia',
    treeMovementPost: 'Miễn là đường đi của nó không bị chặn',
    treeHouse: 'Cây có thể chứa các quân cờ khác, bảo vệ chúng khỏi kẻ địch không thể leo Cây. Có thể các quân cờ có thể leo như Gấu, Hạc, Ếch, Nấm, Dê, Khỉ, Bạch tuộc và Rắn',
    treeHousePost: 'Khi một quân cờ có thể leo cây tấn công, nó chỉ bắt quân cờ được chứa, bảo vệ Cây',
    treeTrample: 'Cây giống như Tê giác, bắt tất cả các quân cờ trên một ô khi nó di chuyển',
    treeTramplePost: 'Bao gồm cả Dê ngất',
    treePlant: 'Cây là thực vật, không phải động vật nên miễn nhiễm với một số hiệu ứng',
    treePlantPost: 'Như độc, biến zombie, vướng víu và nhiễm virus!',

    // Virus
    virusMovement: 'Virus chỉ có thể di chuyển đến các ô có động vật, cách hai ô',
    virusMoveBlocks: 'Virus chỉ có thể di chuyển một ô nếu nó bên cạnh tường',
    virusCaptureHost: 'Khi Virus hạ cánh vào (trong) bất kỳ quân cờ động vật nào, nó chỉ lây nhiễm cho chúng, chúng vẫn có thể tiếp tục chơi thường khi bị nhiễm',
    virusCaptureHostPost: 'Virus chỉ bắt quân cờ khi nó rời khỏi chủ nhà bị nhiễm',
    virusContagion: 'Virus có thể lan rộng nhanh chóng bằng cách lây nhiễm nhiều chủ nhà trong một lượt',
    virusContagionPost: 'Lây nhiễm cho phép Virus thực hiện bao nhiêu nước đi hợp pháp mà nó muốn mỗi lượt',

    // Wolf
    wolfMovement: 'Sói có thể di chuyển theo hình chữ L, giống như mã trong cờ vua',
    wolfMovementPost: 'Nó không bị cản trở bởi bất kỳ quân cờ nào khác',
    wolfLoneWolf: 'Sói',
    wolfLoneWolfPost: 'Sói cũng tự coi mình đơn độc khi nó vẫn còn Dê ngất hoặc đồng minh virus',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Kéo để khám phá • Chụm để phóng to',
    dragToExploreDesktop: '🖱️ Kéo để khám phá • Cuộn để phóng to',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Quay lại',
    next: 'Tiếp theo',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'HỘP CÁT',
    description: 'Thử nghiệm & Luyện tập',
    mode: 'Chế độ:',
    modeValue: 'Hộp cát',
    status: 'Trạng thái:',
    statusReady: 'Sẵn sàng',
    clearBoard: 'Xóa bàn cờ',
  },

  // Multiplayer
  multiplayer: {
    title: 'NHIỀU NGƯỜI CHƠI',
    description: 'Tìm đối thủ và thi đấu!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Trận xếp hạng',
    matchProgress: 'Tiến trình trận đấu',
    gamesCompleted: '{games} / 10 Ván hoàn thành',
    estimatedFinalRating: 'Xếp hạng cuối ước tính',
    startingRating: 'Xếp hạng bắt đầu',
    matchesRemaining: 'Còn {matches} trận',
    findPlacementMatch: 'Tìm trận xếp hạng',

    // Matchmaking modes
    findMatch: 'Tìm trận đấu',
    competitive: 'Thi đấu',
    competitiveDesc: 'Tìm đối thủ gần với xếp hạng của bạn',
    quick: 'Nhanh',
    quickDesc: 'Tìm trận thi đấu nhanh chóng',
    casual: 'Thường',
    casualDesc: 'Không xếp hạng - chơi cho vui!',
    placement: 'Xếp hạng',
    placementDesc: 'Hoàn thành 10 trận để được xếp hạng',
    startSearch: 'Bắt đầu tìm kiếm',

    // Searching
    searching: 'Đang tìm kiếm...',
    mode: 'Chế độ:',
    inQueue: 'Trong hàng đợi:',
    players: 'người chơi',
    playersPlural: 'người chơi',
    cancelSearch: 'Hủy tìm kiếm',

    // Game info
    status: 'Trạng thái:',
    ready: 'Sẵn sàng',
    selectingKing: 'Đang chọn vua',
    placingPieces: 'Đang đặt quân',
    playing: 'Đang chơi',
    gameType: 'Loại trận:',
    opponent: 'Đối thủ:',
    opponentElo: 'ELO đối thủ:',
    unranked: 'Chưa xếp hạng',

    // Piece placement
    dragPieces: 'Kéo quân cờ lên bàn',
    lightPieces: 'Quân sáng (Bạn)',
    darkPieces: 'Quân tối (Bạn)',

    // Waiting states
    waitingForOpponent: 'Đang chờ đối thủ...',
    waitingForKing: 'Đang chờ đối thủ chọn vua...',

    // Warnings
    invalidPlacement: 'Đặt không hợp lệ',
    lightTurn: 'Đến lượt người chơi Sáng!',
    darkTurn: 'Đến lượt người chơi Tối!',
    onlyLightPieces: 'Bạn chỉ có thể đặt quân sáng!',
    onlyDarkPieces: 'Bạn chỉ có thể đặt quân tối!',
    mustPlaceOnRow: 'Quân {color} phải được đặt ở hàng {row}!',

    // Chat
    chat: 'Trò chuyện',
    typeMessage: 'Nhập tin nhắn...',
    send: 'Gửi',
  },

  // Main Page
  mainPage: {
    title: 'CỜ ĐỘNG VẬT',
    subtitle: 'Một trò chơi dành cho con người',
    playersOnline: 'Người chơi trực tuyến hiện tại',
    placement: 'Xếp hạng',
    placementProgress: 'Xếp hạng',
    challengeAI: 'Thách đấu AI',
    multiplayer: 'Nhiều người chơi',
    sandbox: 'Hộp cát',
    tutorials: 'Hướng dẫn',
    shop: 'Cửa hàng',
    collection: 'Bộ sưu tập',
    history: 'Lịch sử',
    analytics: 'Phân tích',
    courses: 'Khóa học',
    upgradeAccount: 'Nâng cấp tài khoản',
    signIn: 'Đăng nhập',
    playAsGuest: 'Chơi với tư cách khách',
    welcomeBack: 'Chào mừng trở lại! Bạn thường chơi với tư cách',

    // Learn the Pieces section
    learnThePieces: 'Học các quân cờ',

    // Learn the Rules section
    learnTheRules: 'Học quy tắc',
    premiseTitle: 'Tiền đề',
    premiseText: 'Zodiac là một trò chơi thay thế cờ vua với vua BÍ MẬT từ danh sách 13 quân cờ, chọn một danh sách độc đáo rồi đánh lừa đối thủ để đánh bại họ trên bàn cờ 5 x 8',
    selectionTitle: 'Lựa chọn',
    selectionText: 'Để bắt đầu trận đấu, hãy bí mật chọn vua của bạn, sau đó đặt 5 quân cờ của bạn luân phiên với đối thủ để tạo ra một trong hơn 500 tỷ trạng thái ban đầu.',
    objectiveTitle: 'Mục tiêu',
    objectiveText: 'Hoặc đọc vị đối thủ để BẮT vua bí mật của họ hoặc CHẠY vua của bạn qua bàn cờ để đảm bảo chiến thắng!',
    competeTitle: 'Thi đấu',
    competeText: 'Thử nghiệm kỹ năng của bạn trên bảng xếp hạng, phát triển các kỹ thuật và chiến lược cá nhân mới, leo hạng để đối đầu với những người giỏi nhất!',
    fullRulesButton: 'Để xem quy tắc chính thức đầy đủ nhấp vào đây',

    // FAQ section
    faqTitle: 'Câu hỏi thường gặp',
    faqQuestion1: 'Ý tưởng đằng sau cờ Zodiac là gì?',
    faqAnswer1: 'Cờ Zodiac ban đầu được lấy cảm hứng từ lời của Bobby Fischer về nguồn cảm hứng tạo ra Chess960, chúng tôi muốn mở rộng ý tưởng chống lại việc ghi nhớ máy móc và tôn vinh trực giác con người trong độ sâu không thể đo lường!',
    faqQuestion2: 'Tại sao chúng ta cần một trò chơi thay thế cờ vua',
    faqAnswer2: 'Chúng ta không cần! Zodiac không muốn lôi kéo mọi người khỏi chơi cờ vua! Đó là một lựa chọn khác với điểm mạnh và điểm yếu riêng, chúng tôi hy vọng bạn sẽ vui vẻ với nó và giúp chúng tôi điều chỉnh trò chơi này để làm sống động các ván chơi mới',
    faqQuestion3: 'Làm thế nào để thắng trong Cờ Zodiac?',
    faqAnswer3: 'Có ba cách để thắng: bắt quân vua bí mật của đối thủ, chạy vua của bạn sang phía bên kia bàn cờ, hoặc trong trận đấu có kiểm soát thời gian, để thời gian của đối thủ hết',
    faqQuestion4: 'Đây có phải là FAQ không?',
    faqAnswer4: 'Có, bạn có thể xem bất kỳ câu hỏi nào được liệt kê trong FAQ và nếu bạn muốn thêm chi tiết, bạn có thể nhấp vào các câu hỏi và sau đó đọc các chi tiết sau, như những chi tiết bạn đang đọc bây giờ',
    faqQuestion5: 'Một ván đấu thường kéo dài bao lâu?',
    faqAnswer5: 'Mỗi ván khác nhau rất nhiều! Một số ván kết thúc sau 2 nước đi và một số có thể mất 30 phút, chúng tôi thường thấy chúng ở mốc 5-15 phút!',
    faqQuestion6: 'Điều gì xảy ra nếu không ai có thể thực hiện nước đi hợp pháp?',
    faqAnswer6: 'Nếu một người chơi không thể thực hiện bất kỳ nước đi hợp pháp nào (bế tắc), trò chơi kết thúc hòa. Trò chơi cũng có thể kết thúc hòa thông qua lặp lại (cùng trạng thái bàn cờ 3 lần) hoặc bằng thỏa thuận chung giữa các người chơi!',

    // About section
    aboutButton: 'Giới thiệu',
    privacyPolicy: 'Chính sách bảo mật',
    developerInterface: 'Giao diện nhà phát triển',
  },

  // About Modal
  about: {
    title: 'Về Zodiac',
    paragraph1: 'Zodiac là trò chơi bàn cờ giống cờ vua kết hợp các yếu tố lựa chọn quân cờ từ các trò chơi như LoL và DotA, với cơ chế đánh lừa từ poker hoặc trò chơi suy luận xã hội.',
    paragraph2: 'Các phiên bản đầu tiên của trò chơi được tạo ra vào năm 2014, dưới tên Shadow Chess. Năm 2018, nó được thiết kế lại để trở thành những gì bạn thấy hôm nay, bao gồm một danh sách các quân cờ thú vị với các mẫu di chuyển và khả năng cân bằng nhưng độc đáo.',
    paragraph3: 'Tầm nhìn của chúng tôi là ghi lại tất cả dữ liệu chơi game của người dùng để tiếp tục phát triển trò chơi trong nỗ lực giữ cho lối chơi mới mẻ, khuyến khích các ván chơi mới.',
    paragraph4: 'Với không gian tìm kiếm khổng lồ của Zodiac, thông tin ẩn và vị trí bàn cờ mở đầu, chúng tôi hy vọng sẽ ngăn chặn sự thống trị của AI và giữ zodiac là một trò chơi dành cho con người!',
  },

  // Privacy Policy
  privacy: {
    title: 'Chính sách bảo mật',
    lastUpdated: 'Cập nhật lần cuối',

    introduction: {
      title: 'Giới thiệu',
      p1: 'Chào mừng đến với Zodiac Chess ("chúng tôi", "của chúng tôi" hoặc "chúng ta"). Chúng tôi cam kết bảo vệ quyền riêng tư của bạn và đảm bảo bạn có trải nghiệm chơi game an toàn và thú vị. Chính sách Bảo mật này giải thích cách chúng tôi thu thập, sử dụng, tiết lộ và bảo vệ thông tin của bạn khi bạn sử dụng trang web và trò chơi của chúng tôi.',
      p2: 'Bằng cách sử dụng Zodiac Chess, bạn đồng ý với việc thu thập và sử dụng thông tin theo chính sách này. Nếu bạn không đồng ý với các chính sách và thực tiễn của chúng tôi, vui lòng không sử dụng dịch vụ của chúng tôi.',
      contact: 'Liên hệ với chúng tôi tại:',
    },

    infoCollect: {
      title: 'Thông tin chúng tôi thu thập',
      accountInfo: {
        title: '1. Thông tin tài khoản',
        item1: 'Địa chỉ Email: Cần thiết để tạo tài khoản và giao tiếp',
        item2: 'Tên người dùng: Tên hiển thị bạn chọn',
        item3: 'Mật khẩu: Được mã hóa và lưu trữ an toàn',
      },
      gameData: {
        title: '2. Dữ liệu trò chơi',
        item1: 'Thống kê trò chơi: Thắng, thua, xếp hạng ELO, tiến trình trận xếp hạng',
        item2: 'Dữ liệu chơi game: Lựa chọn quân cờ, nước đi đã thực hiện, chiến lược đã sử dụng',
        item3: 'Lịch sử trận đấu: Hồ sơ các ván đã chơi, đối thủ đã gặp',
        item4: 'Mua hàng trong trò chơi: Vật phẩm trang trí và trạng thái thành viên cao cấp',
      },
      technicalData: {
        title: '3. Dữ liệu kỹ thuật',
        item1: 'Thông tin thiết bị: Loại trình duyệt, hệ điều hành',
        item2: 'Dữ liệu sử dụng: Trang đã truy cập, thời gian dành ra, tính năng đã sử dụng',
        item3: 'Lưu trữ cục bộ: Tùy chọn ngôn ngữ, cài đặt giao diện, trạng thái trò chơi tạm thời',
      },
    },

    children: {
      title: 'Quyền riêng tư của trẻ em (Tuân thủ COPPA)',
      p1: 'Zodiac Chess được thiết kế thân thiện với gia đình và phù hợp cho người chơi ở mọi lứa tuổi, bao gồm cả trẻ em. Chúng tôi đặc biệt chú ý tuân thủ Đạo luật Bảo vệ Quyền riêng tư Trực tuyến của Trẻ em (COPPA).',
      p2: 'Đối với người dùng dưới 13 tuổi: Chúng tôi khuyến nghị trẻ em sử dụng chế độ chơi khách của chúng tôi, không yêu cầu tạo tài khoản hoặc thu thập dữ liệu. Tài khoản khách không có quyền truy cập vào các tính năng trò chuyện văn bản, đảm bảo trẻ em không tiếp xúc với giao tiếp với internet rộng hơn. Nếu trẻ em tạo tài khoản, chúng tôi yêu cầu sự đồng ý của cha mẹ trước khi thu thập bất kỳ thông tin cá nhân nào.',
      p3: 'Chúng tôi KHÔNG cố ý thu thập, sử dụng hoặc chia sẻ thông tin cá nhân từ trẻ em dưới 13 tuổi mà không có sự đồng ý đã xác minh của cha mẹ.',
      p4: 'An toàn Trò chuyện: Trò chuyện văn bản tự động bị tắt cho tất cả tài khoản khách/tạm thời. Chủ tài khoản tiêu chuẩn có tùy chọn tắt chức năng trò chuyện trong cài đặt tài khoản của họ bất cứ lúc nào.',
      parentalRights: 'Cha mẹ có quyền:',
      right1: 'Xem xét thông tin cá nhân của con họ',
      right2: 'Yêu cầu xóa dữ liệu của con họ',
      right3: 'Từ chối thu thập hoặc sử dụng thêm thông tin của con họ',
      contactUs: 'Để thực hiện các quyền này hoặc nếu bạn tin rằng con bạn đã cung cấp thông tin cá nhân cho chúng tôi, vui lòng liên hệ với chúng tôi ngay tại contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'Cách chúng tôi sử dụng thông tin của bạn',
      item1: 'Cung cấp và cải thiện dịch vụ trò chơi của chúng tôi',
      item2: 'Ghép bạn với đối thủ phù hợp dựa trên cấp độ kỹ năng',
      item3: 'Theo dõi tiến trình, thống kê và thành tích của bạn',
      item4: 'Xử lý thanh toán cho thành viên cao cấp và vật phẩm trang trí',
      item5: 'Gửi thông báo dịch vụ quan trọng và cập nhật',
      item6: 'Phân tích dữ liệu chơi game để cải thiện cân bằng trò chơi và tính năng',
    },

    thirdParty: {
      title: 'Dịch vụ bên thứ ba',
      firebase: {
        title: 'Firebase (Google)',
        description: 'Chúng tôi sử dụng Firebase để xác thực, lưu trữ cơ sở dữ liệu và chức năng nhiều người chơi. Firebase có thể thu thập một số dữ liệu như được mô tả trong chính sách bảo mật của họ.',
      },
      stripe: {
        title: 'Stripe',
        description: 'Chúng tôi sử dụng Stripe để xử lý thanh toán cho thành viên cao cấp và mua hàng trong ứng dụng. Stripe xử lý tất cả thông tin thẻ thanh toán - chúng tôi không bao giờ xem hoặc lưu trữ chi tiết thanh toán đầy đủ của bạn.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Trang web của chúng tôi được lưu trữ trên Netlify, có thể thu thập dữ liệu lưu trữ web tiêu chuẩn như địa chỉ IP và nhật ký truy cập.',
      },
      adsense: {
        title: 'Google AdSense (Tương lai)',
        description: 'Chúng tôi có thể hiển thị quảng cáo thông qua Google AdSense. Các quảng cáo này có thể sử dụng cookie để cá nhân hóa. Đối với nội dung hướng đến trẻ em, chúng tôi sẽ chỉ hiển thị quảng cáo không được cá nhân hóa tuân thủ COPPA.',
      },
      viewPolicy: 'Xem Chính sách Bảo mật của họ',
    },

    cookies: {
      title: 'Cookie và Lưu trữ cục bộ',
      description: 'Chúng tôi sử dụng lưu trữ cục bộ của trình duyệt (tương tự như cookie) để nâng cao trải nghiệm của bạn:',
      item1: 'Tùy chọn Ngôn ngữ: Ghi nhớ ngôn ngữ bạn đã chọn',
      item2: 'Phiên Tài khoản: Giữ bạn đăng nhập (hoạt động với Firebase)',
      item3: 'Cài đặt Trò chơi: Ghi nhớ tùy chọn giao diện và thiết lập hộp cát của bạn',
      item4: 'Cookie Quảng cáo: Nếu bạn đồng ý, các dịch vụ quảng cáo bên thứ ba có thể sử dụng cookie để cá nhân hóa quảng cáo',
    },

    security: {
      title: 'Bảo mật dữ liệu',
      p1: 'Chúng tôi thực hiện các biện pháp bảo mật thích hợp để bảo vệ thông tin của bạn:',
      item1: 'Mã hóa Mật khẩu: Tất cả mật khẩu được mã hóa bằng các phương pháp tiêu chuẩn ngành',
      item2: 'Kết nối An toàn: Mã hóa HTTPS cho tất cả truyền dữ liệu',
      item3: 'Quy tắc Bảo mật Firebase: Kiểm soát truy cập cơ sở dữ liệu nghiêm ngặt',
      p2: 'Tuy nhiên, không có phương pháp truyền qua internet nào an toàn 100%. Mặc dù chúng tôi cố gắng bảo vệ dữ liệu của bạn, chúng tôi không thể đảm bảo bảo mật tuyệt đối.',
    },

    retention: {
      title: 'Lưu giữ dữ liệu',
      p1: 'Chúng tôi lưu giữ dữ liệu của bạn như sau:',
      item1: 'Tài khoản Hoạt động: Dữ liệu được lưu giữ trong khi tài khoản của bạn đang hoạt động',
      item2: 'Tài khoản Không hoạt động: Nếu tài khoản của bạn không hoạt động trong 10 năm, chúng tôi có thể xóa dữ liệu của bạn',
    },

    rights: {
      title: 'Quyền riêng tư của bạn',
      description: 'Tùy thuộc vào vị trí của bạn, bạn có thể có các quyền sau:',
      access: {
        title: 'Truy cập:',
        description: 'Yêu cầu bản sao dữ liệu cá nhân của bạn',
      },
      correction: {
        title: 'Sửa chữa:',
        description: 'Yêu cầu sửa chữa dữ liệu của bạn',
      },
      deletion: {
        title: 'Xóa:',
        description: 'Yêu cầu xóa tài khoản và dữ liệu của bạn',
      },
      portability: {
        title: 'Khả năng Di chuyển Dữ liệu:',
        description: 'Yêu cầu dữ liệu của bạn ở định dạng di động',
      },
      optOut: {
        title: 'Từ chối:',
        description: 'Từ chối nhận thông tin tiếp thị',
      },
      contact: 'Để thực hiện bất kỳ quyền nào trong số này, vui lòng liên hệ với chúng tôi tại contact@zodiac-chess.com',
    },

    international: {
      title: 'Người dùng quốc tế',
      p1: 'Zodiac Chess được vận hành từ New Zealand. Nếu bạn truy cập dịch vụ của chúng tôi từ bên ngoài New Zealand, vui lòng lưu ý rằng thông tin của bạn có thể được chuyển đến, lưu trữ và xử lý tại New Zealand và các quốc gia khác nơi các nhà cung cấp dịch vụ của chúng tôi hoạt động.',
      p2: 'Bằng cách sử dụng dịch vụ của chúng tôi, bạn đồng ý với việc chuyển thông tin của bạn đến các quốc gia bên ngoài quốc gia cư trú của bạn, có thể có luật bảo vệ dữ liệu khác nhau.',
    },

    changes: {
      title: 'Thay đổi đối với Chính sách Bảo mật này',
      description: 'Chúng tôi có thể cập nhật Chính sách Bảo mật này theo thời gian. Chúng tôi sẽ thông báo cho bạn về bất kỳ thay đổi nào bằng cách đăng Chính sách Bảo mật mới trên trang này và cập nhật ngày "Cập nhật lần cuối". Những thay đổi quan trọng sẽ được thông báo qua email hoặc thông báo nổi bật trên trang web của chúng tôi.',
    },

    contact: {
      title: 'Liên hệ với chúng tôi',
      description: 'Nếu bạn có bất kỳ câu hỏi, mối quan tâm hoặc yêu cầu nào liên quan đến Chính sách Bảo mật này hoặc thực tiễn dữ liệu của chúng tôi, vui lòng liên hệ với chúng tôi:',
      email: 'Email:',
      company: 'Công ty:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Điều Khoản Dịch Vụ',
    lastUpdated: 'Cập nhật lần cuối',
    back: 'Quay lại',
    viewPrivacyPolicy: 'Xem Chính Sách Bảo Mật',
    acknowledgment: 'Bằng việc sử dụng Zodiac Chess, bạn xác nhận rằng bạn đã đọc, hiểu và đồng ý tuân theo các Điều Khoản Dịch Vụ này.',
    acceptance: {
      title: '1. Chấp Nhận Điều Khoản',
      p1: 'Bằng việc truy cập và sử dụng Zodiac Chess ("Dịch Vụ"), bạn chấp nhận và đồng ý tuân theo các Điều Khoản Dịch Vụ này. Nếu bạn không đồng ý với các điều khoản này, vui lòng không sử dụng Dịch Vụ.',
      p2: 'Chúng tôi có quyền sửa đổi các điều khoản này bất cứ lúc nào. Việc tiếp tục sử dụng Dịch Vụ sau khi thay đổi đồng nghĩa với việc chấp nhận các điều khoản đã sửa đổi.',
    },
    description: {
      title: '2. Mô Tả Dịch Vụ',
      p1: 'Zodiac Chess là trò chơi bàn cờ chiến lược trực tuyến với các quân cờ động vật độc đáo có khả năng đặc biệt. Dịch Vụ bao gồm:',
      feature1: 'Chơi đơn với đối thủ AI',
      feature2: 'Ghép trận nhiều người chơi và chế độ cạnh tranh',
      feature3: 'Hướng dẫn tương tác và tài nguyên học tập',
      feature4: 'Tạo tài khoản và theo dõi tiến trình',
      feature5: 'Tính năng đăng ký premium tùy chọn',
      feature6: 'Tùy chọn tùy chỉnh ngoại hình',
    },
    accounts: {
      title: '3. Tài Khoản Người Dùng',
      eligibility: {
        title: '3.1 Điều Kiện',
        p1: 'Bạn phải ít nhất 13 tuổi để tạo tài khoản. Người dùng dưới 13 tuổi có thể sử dụng chế độ chơi khách dưới sự giám sát của phụ huynh nhưng không thể tạo tài khoản.',
      },
      responsibilities: {
        title: '3.2 Bảo Mật Tài Khoản',
        p1: 'Bạn chịu trách nhiệm về:',
        item1: 'Duy trì tính bảo mật của mật khẩu',
        item2: 'Tất cả hoạt động xảy ra dưới tài khoản của bạn',
        item3: 'Thông báo ngay cho chúng tôi về bất kỳ việc sử dụng trái phép nào',
        p2: 'Chúng tôi không chịu trách nhiệm về bất kỳ tổn thất hoặc thiệt hại nào phát sinh từ việc truy cập tài khoản trái phép.',
      },
      prohibited: {
        title: '3.3 Hoạt Động Bị Cấm',
        p1: 'Bạn KHÔNG được:',
        item1: 'Chia sẻ tài khoản với người khác',
        item2: 'Sử dụng nhiều tài khoản để thao túng xếp hạng',
        item3: 'Sử dụng bot, script hoặc công cụ tự động để chơi game',
        item4: 'Quấy rối, lạm dụng hoặc đe dọa người chơi khác',
        item5: 'Khai thác lỗi hoặc sự cố để có lợi thế không công bằng',
        item6: 'Dịch ngược hoặc cố gắng truy cập mã nguồn của chúng tôi',
        p2: 'Vi phạm các quy tắc này có thể dẫn đến tạm ngưng tài khoản hoặc cấm vĩnh viễn.',
      },
    },
    premium: {
      title: '4. Đăng Ký Premium',
      billing: {
        title: '4.1 Thanh Toán',
        p1: 'Đăng ký premium được xử lý thông qua Stripe. Bằng việc mua đăng ký premium, bạn cho phép chúng tôi tính phí phương thức thanh toán của bạn định kỳ cho đến khi bạn hủy.',
        p2: 'Phí đăng ký:',
        item1: 'Gói Hàng Tháng: Tính phí hàng tháng vào ngày kỷ niệm mua hàng',
        item2: 'Gói Hàng Năm: Tính phí hàng năm vào ngày kỷ niệm mua hàng',
        p3: 'Giá có thể thay đổi với thông báo trước 30 ngày cho người đăng ký đang hoạt động.',
      },
      cancellation: {
        title: '4.2 Hủy Bỏ',
        p1: 'Bạn có thể hủy đăng ký bất cứ lúc nào thông qua cài đặt tài khoản hoặc liên hệ hỗ trợ. Việc hủy có hiệu lực vào cuối kỳ thanh toán hiện tại.',
        p2: 'Bạn sẽ giữ lại các tính năng premium cho đến hết thời gian đã thanh toán, ngay cả sau khi hủy.',
      },
      refunds: {
        title: '4.3 Hoàn Tiền',
        p1: 'Đăng ký hàng tháng: Không hoàn tiền cho tháng không đầy đủ. Hủy bất cứ lúc nào để dừng các khoản phí trong tương lai.',
        p2: 'Đăng ký hàng năm: Hoàn tiền đầy đủ nếu yêu cầu trong vòng 7 ngày kể từ ngày mua. Sau 7 ngày, việc hoàn tiền tùy thuộc vào quyết định của chúng tôi.',
        p3: 'Mua hàng trang trí: Thường không hoàn tiền. Liên hệ hỗ trợ cho các trường hợp đặc biệt.',
      },
    },
    acceptable: {
      title: '5. Chính Sách Sử Dụng Chấp Nhận Được',
      p1: 'Bạn đồng ý sử dụng Zodiac Chess một cách tôn trọng và hợp pháp. Hành vi bị cấm bao gồm:',
      item1: 'Gian lận, hack hoặc khai thác cơ chế trò chơi',
      item2: 'Quấy rối, phát ngôn thù địch hoặc ngôn ngữ phân biệt đối xử',
      item3: 'Spam, quảng cáo hoặc mời chào',
      item4: 'Chia sẻ nội dung không phù hợp (nếu chat hoặc nội dung do người dùng tạo được bật)',
      item5: 'Mạo danh người dùng khác hoặc nhân viên',
      item6: 'Cố gắng gây rối hoặc làm hỏng Dịch Vụ',
      p2: 'Chúng tôi có quyền điều tra vi phạm và thực hiện hành động thích hợp, bao gồm chấm dứt tài khoản và báo cáo cho cơ quan chức năng nếu cần.',
    },
    intellectual: {
      title: '6. Quyền Sở Hữu Trí Tuệ',
      ownership: {
        title: '6.1 Nội Dung Của Chúng Tôi',
        p1: 'Tất cả nội dung trò chơi, bao gồm nhưng không giới hạn ở cơ chế trò chơi, tác phẩm nghệ thuật, hoạt hình, hiệu ứng âm thanh, mã và thiết kế, thuộc sở hữu của Animal Chess Limited hoặc các bên cấp phép của chúng tôi.',
        p2: 'Bạn được cấp giấy phép hạn chế, không độc quyền, không thể chuyển nhượng để sử dụng Dịch Vụ chỉ cho mục đích giải trí cá nhân.',
      },
      userContent: {
        title: '6.2 Nội Dung Người Dùng',
        p1: 'Bằng việc gửi nội dung (như tin nhắn chat, tên người dùng hoặc thông tin hồ sơ), bạn cấp cho chúng tôi giấy phép toàn cầu, miễn phí bản quyền để sử dụng, hiển thị và phân phối nội dung đó liên quan đến Dịch Vụ.',
        p2: 'Bạn đại diện rằng bạn sở hữu hoặc có các quyền cần thiết đối với bất kỳ nội dung nào bạn gửi.',
      },
    },
    disclaimers: {
      title: '7. Từ Chối Trách Nhiệm và Giới Hạn Trách Nhiệm',
      p1: 'DỊCH VỤ ĐƯỢC CUNG CẤP "NGUYÊN TRẠNG" MÀ KHÔNG CÓ BẤT KỲ BẢO ĐẢM NÀO, DÙ RÕ RÀNG HAY NGẦM ĐỊNH.',
      p2: 'Chúng tôi không đảm bảo rằng:',
      item1: 'Dịch Vụ sẽ không bị gián đoạn hoặc không có lỗi',
      item2: 'Các khiếm khuyết sẽ được sửa chữa',
      item3: 'Dịch Vụ không có virus hoặc thành phần có hại',
      item4: 'Kết quả từ việc sử dụng Dịch Vụ sẽ đáp ứng kỳ vọng của bạn',
      p3: 'TRONG PHẠM VI TỐI ĐA ĐƯỢC PHÁP LUẬT CHO PHÉP, CHÚNG TÔI KHÔNG CHỊU TRÁCH NHIỆM VỀ:',
      item5: 'Bất kỳ thiệt hại gián tiếp, ngẫu nhiên hoặc hậu quả nào',
      item6: 'Mất lợi nhuận, dữ liệu hoặc uy tín',
      item7: 'Gián đoạn dịch vụ hoặc mất dữ liệu',
      item8: 'Thiệt hại vượt quá số tiền bạn đã trả cho chúng tôi trong 12 tháng qua',
    },
    privacy: {
      title: '8. Bảo Mật',
      p1: 'Việc sử dụng Dịch Vụ của bạn cũng được điều chỉnh bởi Chính Sách Bảo Mật của chúng tôi, giải thích cách chúng tôi thu thập, sử dụng và bảo vệ thông tin cá nhân của bạn.',
      p2: 'Bằng việc sử dụng Dịch Vụ, bạn đồng ý với các hoạt động dữ liệu của chúng tôi như được mô tả trong Chính Sách Bảo Mật.',
    },
    changes: {
      title: '9. Thay Đổi Điều Khoản',
      p1: 'Chúng tôi có quyền sửa đổi các Điều Khoản Dịch Vụ này bất cứ lúc nào. Chúng tôi sẽ thông báo cho người dùng về các thay đổi quan trọng qua:',
      item1: 'Thông báo email cho người dùng đã đăng ký',
      item2: 'Thông báo nổi bật trên trang web',
      item3: 'Ngày "Cập nhật lần cuối" được cập nhật ở đầu trang này',
      p2: 'Việc tiếp tục sử dụng Dịch Vụ sau khi thay đổi đồng nghĩa với việc chấp nhận các điều khoản đã sửa đổi.',
    },
    governing: {
      title: '10. Luật Điều Chỉnh',
      p1: 'Các Điều Khoản Dịch Vụ này được điều chỉnh bởi luật pháp New Zealand, không tính đến các nguyên tắc xung đột pháp luật.',
      p2: 'Mọi tranh chấp phát sinh từ các điều khoản này hoặc việc sử dụng Dịch Vụ của bạn sẽ được giải quyết tại tòa án New Zealand.',
    },
    contact: {
      title: '11. Thông Tin Liên Hệ',
      p1: 'Đối với câu hỏi, lo ngại hoặc hỗ trợ về các Điều Khoản Dịch Vụ này:',
      email: 'Email:',
      company: 'Công ty:',
      address: 'Địa chỉ:',
    },
    severability: {
      title: '12. Khả Năng Tách Rời',
      p1: 'Nếu bất kỳ điều khoản nào trong các điều khoản này được xác định là không thể thi hành hoặc không hợp lệ, điều khoản đó sẽ bị giới hạn hoặc loại bỏ ở mức tối thiểu cần thiết, và các điều khoản còn lại sẽ vẫn có đầy đủ hiệu lực.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Chính Sách Cookie',
    lastUpdated: 'Cập Nhật Lần Cuối',
    browserInstructions: {
      chrome: 'Cài đặt → Quyền riêng tư và Bảo mật → Cookie',
      firefox: 'Cài đặt → Quyền riêng tư & Bảo mật → Cookie và Dữ liệu trang web',
      safari: 'Tùy chọn → Quyền riêng tư → Cookie và dữ liệu trang web',
      edge: 'Cài đặt → Quyền riêng tư, tìm kiếm và dịch vụ → Cookie',
    },
    cookieTable: {
      name: 'Tên Cookie',
      purpose: 'Mục đích',
      duration: 'Thời hạn',
      type: 'Loại',
    },
    relatedPolicies: {
      title: 'Chính Sách Liên Quan',
      description: 'Để biết thêm thông tin về cách chúng tôi xử lý dữ liệu của bạn, vui lòng xem:',
      privacy: 'Chính Sách Bảo Mật',
      terms: 'Điều Khoản Dịch Vụ',
    },

    introduction: {
      title: 'Giới Thiệu',
      p1: 'Chính Sách Cookie này giải thích cách Zodiac Chess ("chúng tôi") sử dụng cookie và các công nghệ tương tự khi bạn truy cập trang web của chúng tôi.',
      p2: 'Bằng việc sử dụng trang web của chúng tôi, bạn đồng ý với việc sử dụng cookie theo chính sách này. Nếu bạn không đồng ý, vui lòng tắt cookie trong cài đặt trình duyệt hoặc không sử dụng trang web của chúng tôi.',
    },
    what: {
      title: 'Cookie Là Gì?',
      p1: 'Cookie là các tệp văn bản nhỏ được đặt trên thiết bị của bạn (máy tính, điện thoại thông minh, máy tính bảng) khi bạn truy cập trang web. Chúng được sử dụng rộng rãi để làm cho các trang web hoạt động hiệu quả và cung cấp thông tin cho chủ sở hữu trang web.',
      p2: 'Cookie phục vụ nhiều mục đích khác nhau, bao gồm ghi nhớ tùy chọn của bạn, phân tích việc sử dụng trang web và kích hoạt các tính năng nhất định.',
    },
    types: {
      title: 'Các Loại Cookie Chúng Tôi Sử Dụng',
      necessary: {
        title: '1. Cookie Cần Thiết',
        description: 'Các cookie này rất cần thiết để trang web hoạt động đúng cách. Nếu không có các cookie này, các dịch vụ bạn yêu cầu không thể được cung cấp.',
        examples: 'Ví dụ:',
        item1: 'Cookie xác thực - Giữ bạn đăng nhập vào tài khoản của mình',
        item2: 'Cookie bảo mật - Bảo vệ chống lại hoạt động gian lận',
        item3: 'Cookie phiên - Duy trì trạng thái trò chơi của bạn trong một phiên',
        item4: 'Tùy chọn đồng ý cookie - Ghi nhớ lựa chọn cookie của bạn',
      },
      analytics: {
        title: '2. Cookie Phân Tích',
        description: 'Các cookie này giúp chúng tôi hiểu cách khách truy cập tương tác với trang web bằng cách thu thập thông tin ẩn danh về lượt truy cập trang, thời gian dành và các tính năng được sử dụng.',
        provider: 'Nhà cung cấp: Firebase Analytics (Google)',
        purpose: 'Mục đích:',
        item1: 'Đo lường lưu lượng truy cập trang web và mức độ tương tác của người dùng',
        item2: 'Xác định các tính năng và trang phổ biến',
        item3: 'Hiểu nhân khẩu học người dùng (độ tuổi, vị trí chung)',
        item4: 'Cải thiện hiệu suất trang web và trải nghiệm người dùng',
      },
      advertising: {
        title: '3. Cookie Quảng Cáo',
        description: 'Các cookie này được sử dụng để hiển thị quảng cáo phù hợp với bạn. Chúng cũng giới hạn số lần bạn nhìn thấy quảng cáo và giúp đo lường hiệu quả của các chiến dịch quảng cáo.',
        provider: 'Nhà cung cấp: Google AdSense',
        purpose: 'Mục đích:',
        item1: 'Hiển thị quảng cáo được cá nhân hóa dựa trên sở thích của bạn',
        item2: 'Đo lường hiệu suất và mức độ tương tác của quảng cáo',
        item3: 'Ngăn hiển thị cùng một quảng cáo quá nhiều lần',
        note: 'Lưu ý: Người đăng ký Premium không bao giờ thấy quảng cáo, bất kể cài đặt cookie.',
      },
    },
    firstThird: {
      title: 'Cookie Bên Thứ Nhất vs Cookie Bên Thứ Ba',
      firstParty: {
        title: 'Cookie Bên Thứ Nhất',
        description: 'Đây là các cookie được đặt trực tiếp bởi Zodiac Chess. Chúng tôi sử dụng chúng cho chức năng trang web thiết yếu, xác thực và ghi nhớ tùy chọn của bạn.',
      },
      thirdParty: {
        title: 'Cookie Bên Thứ Ba',
        description: 'Đây là các cookie được đặt bởi các dịch vụ bên ngoài mà chúng tôi sử dụng, như Google Analytics và Google AdSense. Cookie bên thứ ba tuân theo chính sách bảo mật của các nhà cung cấp đó.',
      },
    },
    specific: {
      title: 'Cookie Cụ Thể Chúng Tôi Sử Dụng',
      tableHeader: 'Dưới đây là danh sách chi tiết các cookie được sử dụng trên trang web của chúng tôi:',
    },
    control: {
      title: 'Cách Kiểm Soát Cookie',
      consent: {
        title: '1. Banner Đồng Ý Cookie',
        description: 'Khi bạn truy cập trang web của chúng tôi lần đầu tiên, bạn sẽ thấy banner đồng ý cookie. Bạn có thể:',
        item1: 'Chấp Nhận Tất Cả - Cho phép tất cả cookie (cần thiết, phân tích và quảng cáo)',
        item2: 'Từ Chối Tùy Chọn - Chỉ cho phép cookie cần thiết (không có phân tích hoặc quảng cáo)',
        item3: 'Tùy Chỉnh - Chọn chính xác loại cookie bạn muốn cho phép',
      },
      browser: {
        title: '2. Cài Đặt Trình Duyệt',
        description: 'Hầu hết các trình duyệt web cho phép bạn kiểm soát cookie thông qua cài đặt của chúng. Bạn có thể:',
        item1: 'Chặn tất cả cookie',
        item2: 'Chỉ chấp nhận cookie bên thứ nhất',
        item3: 'Xóa cookie sau mỗi phiên duyệt web',
        item4: 'Xem và xóa từng cookie riêng lẻ',
        links: 'Đây là các liên kết đến quản lý cookie cho các trình duyệt phổ biến:',
      },
      optOut: {
        title: '3. Công Cụ Từ Chối',
        description: 'Đặc biệt đối với cookie quảng cáo, bạn có thể từ chối quảng cáo được cá nhân hóa:',
        googleLink: 'Cài Đặt Quảng Cáo Google',
        googleDesc: ' - Quản lý quảng cáo được cá nhân hóa của Google',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Từ chối quảng cáo dựa trên sở thích',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - Công cụ từ chối dành riêng cho EU',
      },
    },
    impact: {
      title: 'Tác Động Của Việc Tắt Cookie',
      p1: 'Nếu bạn tắt hoặc từ chối cookie, xin lưu ý rằng:',
      item1: 'Một số phần của trang web có thể không hoạt động đúng cách',
      item2: 'Bạn có thể cần nhập lại tùy chọn của mình mỗi lần truy cập',
      item3: 'Bạn có thể bị đăng xuất khỏi tài khoản của mình',
      item4: 'Cookie cần thiết là bắt buộc để trang web hoạt động - tắt chúng sẽ ngăn bạn sử dụng các tính năng cốt lõi',
    },
    updates: {
      title: 'Cập Nhật Chính Sách Cookie Này',
      p1: 'Chúng tôi có thể cập nhật Chính Sách Cookie này theo thời gian để phản ánh những thay đổi trong thực tiễn của chúng tôi hoặc vì lý do pháp lý, quy định hoặc vận hành.',
      p2: 'Chúng tôi sẽ thông báo cho bạn về những thay đổi quan trọng bằng cách cập nhật ngày "Cập Nhật Lần Cuối" ở đầu trang này. Vui lòng xem lại chính sách này định kỳ.',
    },
    contact: {
      title: 'Liên Hệ Chúng Tôi',
      p1: 'Nếu bạn có câu hỏi về việc sử dụng cookie của chúng tôi hoặc Chính Sách Cookie này, vui lòng liên hệ:',
      email: 'Email:',
      company: 'Công ty:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Chim cánh cụt',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'Gấu',
    Crane: 'Hạc',
    Frog: 'Ếch',
    Fungi: 'Nấm',
    Goat: 'Dê',
    Monkey: 'Khỉ',
    Octopus: 'Bạch tuộc',
    Penguin: 'Chim cánh cụt',
    Rhino: 'Tê giác',
    Snake: 'Rắn',
    Tree: 'Cây',
    Virus: 'Vi rút',
    Wolf: 'Sói',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'New Game',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Timeout',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};
